import { handleFetch } from "@common/utils/Http";

export interface NavItem {
  icon: string;
  label: string;
  url: string;
}

export class PresentationApiClient {
  private baseURL = "/epp/client";

  getNavItems() {
    return handleFetch<NavItem[]>({
      url: `${this.baseURL}/navigation`,
      method: "GET",
    });
  }
}
